module.exports = __webpack_public_path__ + "static/media/244-lesotho.144bb4f0.svg";